import { XMarkIcon } from "@heroicons/react/24/solid";
import Button from "./Button";

const ConfirmationModal = ({
  title,
  icon,
  description,
  onConfirm,
  confirmLabel = "Confirm",
  colour = "#5C4BF5",
  toggleModal,
  noCancelButton = false,
}) => {
  return (
    <div className="fixed flex left-0 top-0 z-20 w-full h-screen bg-black bg-opacity-50 backdrop-blur-md items-center justify-center">
      <div className="flex flex-col items-center w-[400px] bg-white rounded-lg">
        <div className="relative flex flex-col w-full p-[24px] items-center justify-center gap-4 text-center">
          <XMarkIcon
            className="absolute top-[24px] right-[24px] w-[24px] h-[24px] cursor-pointer"
            onClick={() => {
              toggleModal();
            }}
          />

          {/* Icons */}
          <div
            className="flex size-[48px] items-center justify-center rounded-full mt-[16px]"
            style={{ backgroundColor: `${colour}20` }}
          >
            {icon}
          </div>

          {/* Header and description */}
          <div className="flex flex-col items-center gap-2">
            <h2 className="font-semibold">{title}</h2>
            <p className="font-normal">{description}</p>
          </div>
        </div>
        <div className="flex items-center w-full p-[24px] gap-2">
          {noCancelButton ? null : (
            <Button
              variant="secondary"
              className="w-full"
              onClick={toggleModal}
            >
              Cancel
            </Button>
          )}
          <Button
            variant="error"
            className="w-full"
            onClick={() => {
              onConfirm();
            }}
          >
            {confirmLabel}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
